import { BusinessForm } from "@nwga/features/businesses/ui";
import { useTRPC } from "@nwga/features/client";
import { Button } from "@nwga/ui/components/button";
import { Skeleton } from "@nwga/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "../../../components/page-header.tsx";

/**
 * The business's own details.
 *
 * Named "Business details" in the navigation rather than "Settings": the only
 * other Settings in this product is the *account* one, and two identically
 * named screens with different owners is how somebody ends up looking for their
 * password on this page.
 */
export const Route = createFileRoute("/dashboard/$businessSlug/settings")({
	component: BusinessSettingsPage,
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			context.trpc.businesses.bySlug.queryOptions({
				slug: params.businessSlug,
			}),
		),
});

function BusinessSettingsPage() {
	const { businessSlug } = Route.useParams();
	const trpc = useTRPC();
	const business = useQuery(
		trpc.businesses.bySlug.queryOptions({ slug: businessSlug }),
	);

	if (!business.isSuccess) return <Skeleton className="h-96 w-full" />;

	return (
		<div className="space-y-6">
			<PageHeader
				title="Business details"
				description="These appear on your public page and on every listing you post."
				actions={
					business.data.status === "active" && (
						<Button asChild variant="outline">
							<Link to="/businesses/$slug" params={{ slug: businessSlug }}>
								View public page
							</Link>
						</Button>
					)
				}
			/>

			<div className="max-w-xl">
				<BusinessForm business={business.data} />
			</div>
		</div>
	);
}
